import { Assert } from "../../../../Assert";
import { Constructor } from "../../../../Extensions";
import { StringHelper } from "../../../../Helpers/StringHelper";
import { Property, PropertyNew, RadObject } from "../../../../RadObject";
import { IAttribute } from "../../System.Runtime/Attribute";
import { BuiltInTypes } from "../../System/BuiltInTypes";
import { Class } from "../../System/Class";
import { NAMESPACE } from "./_Namespace";
import { ITypeInfo } from "./TypeInfo";

export type PropertyInfoPropertyValues =
    {
        attributes: IAttribute[]
        name: string;
        propertyTypeId: string;
    };

export type PropertyInfoProperties = {
    [name in keyof PropertyInfoPropertyValues]?: PropertyInfoPropertyValues[name];
};

export interface IPropertyInfo extends PropertyInfoProperties
{
    attributes?: IAttribute[];
    name: string;
    propertyTypeId: string;
    typeInfo?: ITypeInfo;

    getAttribute<T extends IAttribute>(attribute: Constructor<T>): T | undefined;
}

export class PropertyInfo extends Class implements IPropertyInfo
{
    public static override classNamespace = NAMESPACE + "PropertyInfo";
    public static override className = "PropertyInfo";

    public static forProperty(propertyName: string, property: Property): PropertyInfo
    {
        return new PropertyInfo({
            attributes: property.attributes,
            name: propertyName,
            propertyTypeId: property.dotNetType,
        });
    }

    public attributes?: IAttribute[];
    public name: string;
    public propertyTypeId: string;
    public typeInfo?: ITypeInfo;

    constructor(propertyValues: Partial<PropertyInfoPropertyValues>)
    {
        super();

        Assert.isNotNullOrUndefined(propertyValues.name, "propertyValues.name");
        Assert.isNotNullOrUndefined(propertyValues.propertyTypeId, "propertyValues.propertyTypeId");

        this.attributes = propertyValues.attributes;
        this.name = StringHelper.toLowerCamelCase(propertyValues.name);
        this.propertyTypeId = propertyValues.propertyTypeId;
    }

    public createProperty(context: RadObject)
    {
        if (!this.propertyTypeId)
            throw new Error("propertyTypeId is not set");

        return (
            new PropertyNew({
                attributes: this.attributes,
                initialValue: null,
                dotNetType: this.propertyTypeId as BuiltInTypes,
            })
        );
    }

    public getAttribute<T extends IAttribute>(attribute: Constructor<T>): T | undefined
    {
        return this.attributes?.find(item => item instanceof attribute) as T;
    }
}